export default "__VITE_ASSET__BDBroDJy__"